import { createSvgIcon, type IconName } from "../icons";
import { createEl } from "@/client/utils/createEl";
import { button, type ButtonVariants } from "./button.css";

export type IconPosition = "left" | "right";

export interface ButtonOptions extends NonNullable<ButtonVariants> {
    label: string;
    icon?: IconName;
    iconPosition?: IconPosition;
    onClick?: (event: MouseEvent) => void;
}

const createChildren = (options: ButtonOptions): string | Node[] => {
    if (options.icon === undefined) {
        return options.label;
    }
    const iconEl = createSvgIcon(options.icon);
    const textEl = document.createTextNode(options.label);
    const position = options.iconPosition ?? "left";
    return position === "left" ? [iconEl, textEl] : [textEl, iconEl];
};

export const createButton = (
    options: ButtonOptions,
    init?: (el: HTMLButtonElement) => void,
): HTMLButtonElement => {
    const className = button({
        variant: options.variant,
        size: options.size,
        theme: options.theme,
        iconOnly: options.iconOnly,
    });

    return createEl("button", className, createChildren(options), (el) => {
        el.type = "button";
        if (options.onClick !== undefined) {
            el.addEventListener("click", options.onClick);
        }
        init?.(el);
    });
};
